// Pure audio math helpers (no DOM/WebAudio dependencies)
// Use a deep floor so meters can represent silence without disappearing
export const MIN_DB = -160;

export function rmsDbfs(buf: Float32Array, eps = 1e-8): number {
  let sum = 0;
  for (let i = 0; i < buf.length; i++) sum += buf[i] * buf[i];
  const rms = Math.sqrt(sum / (buf.length || 1));
  const db = 20 * Math.log10(Math.max(rms, eps));
  return db; // dBFS (<= 0)
}

export function gainToDb(g: number, minDb = MIN_DB): number {
  if (!(g > 0)) return minDb;
  return 20 * Math.log10(g);
}

export function clampDb(db: number, floor = MIN_DB, ceil = 0): number {
  return Math.min(ceil, Math.max(floor, db));
}

export function meterFromDb(db: number, floor = MIN_DB, ceil = -3): number {
  const clamped = clampDb(db, floor, ceil);
  return (clamped - floor) / (ceil - floor);
}
